var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValence6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 156 156",
    style: {
      enableBackground: "new 0 0 156 156"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{stroke:#FFFFFF;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M143.8,1.1c5.8,0,10.5,4.7,10.5,10.5v132c0,5.8-4.7,10.5-10.5,10.5h-132c-5.8,0-10.5-4.7-10.5-10.5v-132 C1.3,5.8,6,1.1,11.8,1.1H143.8 M143.8-0.4h-132c-6.6,0-12,5.4-12,12v132c0,6.6,5.4,12,12,12h132c6.6,0,12-5.4,12-12v-132 C155.8,5,150.4-0.4,143.8-0.4L143.8-0.4z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M78,146.5c-37.8,0-68.5-30.7-68.5-68.5S40.2,9.5,78,9.5s68.5,30.7,68.5,68.5S115.8,146.5,78,146.5z M78,14.3 c-35.1,0-63.7,28.6-63.7,63.7c0,35.1,28.6,63.7,63.7,63.7c35.1,0,63.7-28.6,63.7-63.7C141.7,42.9,113.1,14.3,78,14.3z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.1,
    cy: 67.8,
    rx: 6.8,
    ry: 6.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 110.7,
    cy: 67.8,
    rx: 6.8,
    ry: 6.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M107.3,113.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62.3,113.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7,103.3c1.1-2.7,8.7,0.1,30.6,0.2c21.3,0.1,28.4-2.4,29.5,0.2c1.6,4.2-13.5,18.6-30.6,18.3 C69.4,121.7,55.1,107.5,56.7,103.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValence6);
export default __webpack_public_path__ + "static/media/Valence6.6432b5436609f57c324d82a8ce72f338.svg";
export { ForwardRef as ReactComponent };